<cjm-layout-container
	class="c-association-passport-section"
	asidePosition="right"
	alignItems="center"
	classesMain="c-association-passport-section__content"
	layoutType="split-equal"
>
	<ng-container main>
		@if (associationLoading) {
			<ng-container *ngTemplateOutlet="associationPassportLoadingTmpl"></ng-container>
		} @else if (associationProgress && associationName) {
			<h2 class="c-vloket-header c-vloket-header--h2">
				{{
					(associationProgressCompleted
						? i18nKeys.Home.AssociationPassportSection.Titles.CompletedPassportTitle
						: i18nKeys.Home.AssociationPassportSection.Titles.CompletePassportTitle
					) | translate: { associationName: associationName }
				}}
			</h2>

			@if (associationProgressCompleted) {
				<p>
					{{ i18nKeys.Home.AssociationPassportSection.CompletedText | translate }}
				</p>
			}

			<vloket-icon-list [items]="associationProgress" />

			<a
				[routerLink]="[appRoutePaths.MyAssociation]"
				[title]="i18nKeys.Home.AssociationPassportSection.MyAssociationButton.Title | translate"
				[class]="buttonClasses.LinkButton"
			>
				{{ i18nKeys.Home.AssociationPassportSection.MyAssociationButton.Text | translate }}
			</a>
		} @else {
			<h2 class="c-vloket-header c-vloket-header--h2" cypressTag="General.Header.H2">
				{{ i18nKeys.Home.AssociationPassportSection.Titles.DefaultTitle | translate }}
			</h2>

			<p>{{ i18nKeys.Home.AssociationPassportSection.Subtitles.DefaultSubtitle | translate }}</p>

			<vloket-icon-list [items]="items$ | async" />

			<a
				cypressTag="AssociationPassportSection.RegistrationLink"
				[routerLink]="[appRoutePaths.Registration, appRoutePaths.RegistrationStart]"
				[title]="i18nKeys.Home.AssociationPassportSection.RegisterButton.Title | translate"
				[class]="buttonClasses.LinkButton"
			>
				{{ i18nKeys.Home.AssociationPassportSection.RegisterButton.Text | translate }}
			</a>
		}
	</ng-container>
	<div class="c-association-passport-section__image" asideRight>
		<cjm-img
			[src]="
				!associationProgress
					? defaultAssetUrl
					: associationProgressCompleted
						? completedAssetUrl
						: workOnAsssetUrl
			"
		/>
	</div>
</cjm-layout-container>

<ng-template #associationPassportLoadingTmpl>
	<h2 class="c-vloket-header c-vloket-header--h2 u-width-25">
		<ngx-skeleton-loader
			count="1"
			appearance="line"
			[theme]="{
				height: '2.5rem',
				'margin-bottom': 0
			}"
		/>
	</h2>

	<p class="u-width-75">
		<ngx-skeleton-loader count="3" appearance="line" />
	</p>

	<div class="u-width-50">
		<ngx-skeleton-loader
			count="1"
			appearance="line"
			[theme]="{
				height: '2rem',
				'margin-bottom': 0
			}"
		/>
	</div>
</ng-template>
